<template>
	<div>
	  <div class="about">
		<div class="header-image" :style="'background-image:url('+featuredImage+');'" v-if="featuredImage">
			<SubTopNav v-if="title" :title="title" />	
		</div>
		<div v-else :class="'header-image default-header-'+rand">
			<SubTopNav v-if="title" :title="title" />	
		</div>
	    
    	<div class="page-content">
    		
    		<div class="page-grid">
	    		<div  class="content-body item animated fadeInUp" v-for="(item, index) in contentBody" :key="index">
	    			<div class="body-row">
	    				<!-- {{ contentImages[index] }} -->
	    				<div class="body-image" v-if="contentImages && contentImages[index]">
	    					<img :src="contentImages[index].url" v-if="contentImages[index].url">
	    				</div>
	    				<div v-if="index == 0">
			    			<h3>{{ tagline }}</h3>
			    			<div v-html="item.value"></div>
			    		</div>
			    		<div v-else v-html="item.value"></div>
		    			
		    		</div>
	    			
	    		</div>
    		</div>
		</div>
	    
	  </div>
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "about",
	  components: {
	    SubTopNav
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		featuredImage: null,
	  		contentImages: [],
	  		contentBody: null,
	  		title: null,
	  		rand:1,
	  		tagline: null,
	  		siblings:[]
	  	}
	  },
	  methods: {
	  	async getNode(id){
        // var id = "2"
        const { data } = await ContentRepository.getNode(id)
        // console.log('home page data', data)

        this.title = data.title[0].value
        this.tagline = data.body[0].summary
        this.featuredImage = (data.field_feature_image && data.field_feature_image[0] && data.field_feature_image[0].url) ? data.field_feature_image[0].url : null
        this.contentImages = data.field_content_image_s_
        this.contentBody = data.body

        // this.getSiblings()

       
	  	},
	  	// getSiblings(){
	  	// 	var navigation = this.$session.get('navigation')
	  	// 	var pageTitle = this.title.toLowerCase()
	  	// 	if (navigation && navigation.length){
	  	// 		var menuItemArr = navigation.filter(function (item){
		  //         return item.name.toLowerCase() == pageTitle
		  //       })

		  //       var menuItem = menuItemArr[0]
		  //       var menuParent = menuItem.parent


		  //       if (menuParent){
		  //       	var siblingsArr = navigation.filter(function (item){
		  //       		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
		  //       	})

		  //       	this.siblings = siblingsArr

		  //       }

		        

		        
		  //       // console.log('sub expertise', this.subExpertise)
	  	// 	}
	  	// }
	  },
	  mounted(){
	  	var api = this.$route.meta.api
	  	if (api.id && api.type){
	  		if (api.type == "node"){
	  			this.getNode(api.id)
	  		}
	  	}
	  	
	  	this.rand = Math.floor(Math.random() * 8) + 1  
	  }
	};
</script>
<style scoped>
	
	

	.page-grid{
		display:grid;
		grid-template-columns: 1fr 1fr 1fr;
		xgrid-row:1;
		grid-gap:25px;
	}

	.page-grid .item{
		xbackground:#CCC;
		xpadding:10px;
	}

	.page-grid .item:nth-child(1){
		xborder:1px solid red;
		grid-column: 1 / 4;
	}

	.page-grid .item:nth-child(1) .body-row{
		display:grid;
		grid-template-columns: 1fr 2fr;
		background:#f2f2f2;
		xborder:10px solid #e1e1e1;
		xpadding:25px;
		grid-gap:25px;
		margin-top:25px;
		xborder-radius:0px 0px 85px 0px;
	}

	.page-grid .item:nth-child(1) .body-row div:nth-child(1){
		background:#CCC;
		padding:25px;
	}

	.page-grid .item:nth-child(1) .body-row div:nth-child(2) h3{
		margin-top:55px;
	}

	.page-grid .item:nth-child(1) .body-row div:nth-child(2){
		padding:25px;
	}

	.page-grid img{
		max-width:100%;
	}

	.page-grid .item:nth-child(2){
		border-top:5px solid #CC0000;
		padding-top:20px;
		margin-top:20px;
	}

	.page-grid .item:nth-child(3){
		border-top:5px solid #ffcc33;
		padding-top:20px;
		margin-top:20px;
	}

	.page-grid .item:nth-child(4){
		border-top:5px solid #339900;
		padding-top:20px;
		margin-top:20px;
	}

	

	.page-content{
		text-align:left;
		xmargin-bottom:30px;
	}

	.image-break{
		height:300px;
		xbackground:#CCC;
		margin-top:35px;
		margin-bottom:35px;
	}

	.image-box{
		height:300px;
		top:0;
		left:0;
		filter: grayscale(100%);
		xopacity:0.3;
	}

	.image-text{
		margin-top:-300px;
		z-index:50;
		position:relative;
	}

	.image-text a{
		color:#FFF;
	}

	.image-text .container div{
		background:rgba(255,102,0,0.8);
		color:#FFF;
		padding:105px 50px 50px 50px;
		float:left;
		width:50%;
		height:300px
	}

	.page-content .content-body:nth-child(2n) .image-text .container div{
		float:right;
		background:rgba(102,153,51,0.8);
		
	}

	.body-row{
		xpadding:25px;
	}
</style>